<ui-page-header [boxed]="false">Zuletzt bestellte Artikel</ui-page-header>

<p>Hier finden Sie eine Übersicht aller Artikel, die Sie in den letzten 3 Monaten über den neuen Webshop oder die neue
  App bestellt haben.</p>

<mat-accordion [multi]="true">
  @for (node of nodes(); track node.id) {
    <mat-expansion-panel
      class="mat-elevation-z0"
      (expandedChange)="setExpandedCategory($event,node.id)"
      [expanded]="node.id === expandedCategory()"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>{{ node.label }}</mat-panel-title>
      </mat-expansion-panel-header>
      @if (node.id === expandedCategory()) {
        @for (subCategory of node.children; track subCategory.id) {
          @defer (on viewport) {
            <ui-last-ordered-products-table
              [category]="subCategory.id"
              [products]="subCategory.items"
            ></ui-last-ordered-products-table>
          } @placeholder (minimum 200ms) {
            <div>
              @for (x of subCategory.items; track $index) {
                <ngx-skeleton-loader
                  [theme]="{height: '100px', width:'100%', 'border-radius':'0', margin: '0px'}"
                  appearance="circle"
                ></ngx-skeleton-loader>
              }
            </div>
          }
        }
      }
    </mat-expansion-panel>
  }
</mat-accordion>
